function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.5 6.70117C25.7091 6.70117 27.5 8.49203 27.5 10.7012V22.7012C27.5 24.9103 25.7091 26.7012 23.5 26.7012H16.2143L12.0185 31.5962C10.8101 33.006 8.5 32.1515 8.5 30.2947V26.7012H7.5C5.29086 26.7012 3.5 24.9103 3.5 22.7012V10.7012C3.5 8.49203 5.29086 6.70117 7.5 6.70117H23.5Z",
  fill: "#078FCF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5 13.7012C20.2909 13.7012 18.5 15.492 18.5 17.7012V29.7012C18.5 31.9103 20.2909 33.7012 22.5 33.7012H29.7857L33.9815 38.5962C35.1899 40.006 37.5 39.1515 37.5 37.2947V33.7012H38.5C40.7091 33.7012 42.5 31.9103 42.5 29.7012V17.7012C42.5 15.492 40.7091 13.7012 38.5 13.7012H22.5Z",
  fill: "#1CB0F6"
});

var SvgMessageActive = function SvgMessageActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMessageActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/message-active.4b03cdeb.svg";
export { ForwardRef as ReactComponent };